import React, { FC } from 'react';

import { SparePartSearchSummary } from '@savgroup-front-common/types';

import { createGenericContext } from '../../../helpers';
import { AdaptedQuotationNewModel } from '../types/AdaptedQuotationNewModel';

import { QuotationPendingCustomerValidationNewModel } from './QuotationPendingCustomerValidation.types';

export interface IssueAQuotationPageContextArgs {
  alternativeSpareParts: Record<string, Record<string, SparePartSearchSummary>>;
}

const [
  useQuotationPendingCustomerValidationContext,
  IssueAQuotationPageContextProvider,
] = createGenericContext<IssueAQuotationPageContextArgs>();

interface IssueAQuotationPageContextProviderProps {
  quotation:
    | QuotationPendingCustomerValidationNewModel
    | AdaptedQuotationNewModel;
}

const QuotationPendingCustomerValidationContextProvider: FC<
  React.PropsWithChildren<IssueAQuotationPageContextProviderProps>
> = ({ children, quotation }) => {
  const alternativeSpareParts = (quotation.sparePartLines || []).reduce<
    Record<string, Record<string, SparePartSearchSummary>>
  >((acc, line) => {
    const alternatives = line.alternativeSpareParts || [];

    alternatives.forEach((alternative) => {
      if (!acc[line.sparePartId]) {
        acc[line.sparePartId] = {};
      }
      acc[line.sparePartId][
        alternative.sparePartSupplierAssociationId ||
          alternative.sparePartSupplierAssociationId
      ] = alternative as SparePartSearchSummary;
    });

    return acc;
  }, {});

  return (
    <IssueAQuotationPageContextProvider
      value={{
        alternativeSpareParts,
      }}
    >
      {children}
    </IssueAQuotationPageContextProvider>
  );
};

QuotationPendingCustomerValidationContextProvider.displayName =
  'QuotationPendingCustomerValidationContextProvider';

export {
  QuotationPendingCustomerValidationContextProvider,
  useQuotationPendingCustomerValidationContext,
};
